class DeviceColorAllocator {
  availableColors = [
    //'#ff3860', // pink
    //'#4A4A4A', // Dark grey (Not enough contrast)
    '#4786c5', // primary blue (not great contast)
    //'#52bfbf', // Green (Not enough contrast)
    //'#4c4acc', // purple
  ];

  allocations = {};

  allocationCounter = 0;

  getColor = (deviceId) => {
    if (this.allocations[deviceId]) {
      return this.allocations[deviceId];
    }

    return this._allocateColor(deviceId);
  }

  _allocateColor = (deviceId) => {
    const ix = this.allocationCounter % this.availableColors.length;
    this.allocations[deviceId] = this.availableColors[ix];
    this.allocationCounter = this.allocationCounter + 1;
    return this.allocations[deviceId];
  }
}

export default DeviceColorAllocator;
